// Shared professional profile list — used across public form, back-office, filters and stats.
export const PROFILES = [
  "Architecte",
  "BET / Ingénierie",
  "Façadier / Entreprise de façade",
  "Entreprise générale",
  "Maître d'ouvrage",
  "Promoteur / Foncière",
  "Bailleur social",
  "Industriel / Fabricant",
  "Économiste de la construction",
  "AMO / Conseil",
  "Enseignement / Recherche",
  "Institution / Organisation professionnelle",
  "Presse / Média",
  "Étudiant",
  "Autre",
];

export const REG_STATUSES = [
  "À valider",
  "Confirmé",
  "Liste d'attente",
  "Refusé",
  "Annulé",
  "Présent",
  "Absent",
];

export const CONTENT_TYPES = [
  "Article",
  "Expertise",
  "Retour d'expérience",
  "Projet",
  "Interview",
  "Décryptage",
];

export const STATUS_COLORS = {
  "À valider": "bg-amber-100 text-amber-700",
  "Confirmé": "bg-f2b-cyan/15 text-f2b-cyan",
  "Liste d'attente": "bg-f2b-gold/15 text-f2b-gold",
  "Refusé": "bg-red-100 text-red-600",
  "Annulé": "bg-gray-200 text-gray-500",
  "Présent": "bg-green-100 text-green-700",
  "Absent": "bg-gray-100 text-gray-500",
  "Intéressé": "bg-purple-100 text-purple-600",
};
